import { useMemo } from 'react';
import { primitiveTypeUniq } from '@mews/fp';
import { getCurrentEnterpriseReservationsByIds } from '@mews-commander/legacy-entities/src/selectors/reservations';
import { useCommanderSelector } from '@mews-commander/utils';

export const useReservationsCommonInterval = (reservationIds: string[]) => {
    const reservations = useCommanderSelector((state) =>
        getCurrentEnterpriseReservationsByIds(state, { ids: reservationIds })
    );

    return useMemo(() => {
        const { startUtcs, endUtcs } = reservations.reduce(
            (acc, { startUtc, endUtc }) => {
                acc.startUtcs.push(startUtc);
                acc.endUtcs.push(endUtc);
                return acc;
            },
            { startUtcs: [] as string[], endUtcs: [] as string[] }
        );

        const uniqueStartUtcs = primitiveTypeUniq(startUtcs);
        const uniqueEndUtcs = primitiveTypeUniq(endUtcs);

        return {
            startUtc: uniqueStartUtcs.length === 1 ? uniqueStartUtcs[0] : undefined,
            endUtc: uniqueEndUtcs.length === 1 ? uniqueEndUtcs[0] : undefined,
        };
    }, [reservations]);
};
